import { Address } from '@synergy/models';

export const getAddressDisplayValue = (address: Partial<Address>): string => {
    const title = address.title ? `${address.title}, ` : '';
    const street = `${address.street} ${address.number || ''}  ${address.addition || ''}`.trim();
    const city = `${address.zip || ''} ${address.city || ''}`.trim();
    return `${title}${street}, ${city}`;
};
